import { useMemo } from "react";
import { POOL_IDS } from "src/config/poolsConfig";
import { CHAIN_ALIASES } from "src/wallet-connection/chains";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

export const EXPLORER_TYPE = {
  ADDRESS: "address",
  TRANSACTION: "transaction",
};

const exploreConfig = {
  [CHAIN_ALIASES.BSC_MAINNET]: {
    address: "https://bscscan.com/address",
    transaction: "https://bscscan.com/tx",
    label: "bscscan",
  },
  [CHAIN_ALIASES.FTM_MAINNET]: {
    address: "https://ftmscan.com/address",
    transaction: "https://ftmscan.com/tx",
    label: "ftmscan",
  },
  [CHAIN_ALIASES.ETH_MAINNET]: {
    address: "https://etherscan.io/address",
    transaction: "https://etherscan.io/tx",
    label: "etherscan",
  },
};

export default function useExplorerUrl(hash, config = {}) {
  const { chain } = useWeb3Connect();
  const { chainId: configChainId, pool, type: configType } = config;

  const chainId = useMemo(() => {
    if (!pool) return configChainId ?? chain.chainId;
    if (pool === POOL_IDS.TRAVA_BSC) return CHAIN_ALIASES.BSC_MAINNET;
    else if (pool === POOL_IDS.TRAVA_FTM) return CHAIN_ALIASES.FTM_MAINNET;
    else if (pool === POOL_IDS.TRAVA_ETH) return CHAIN_ALIASES.ETH_MAINNET;
  }, [configChainId, pool]);

  const type = configType ?? EXPLORER_TYPE.ADDRESS;

  return useMemo(() => {
    if (exploreConfig[chainId]) {
      const _config = exploreConfig[chainId];
      return { link: `${_config[type]}/${hash}`, text: _config["label"] };
    } else return { link: "", text: "" };
  }, [hash, chainId, type]);
}
